/* global console require */

import Vue from "vue";
import $ from "jquery";
import moment from "moment";
import locale from "locale";
import dotdotdot from "dotdotdot";

//TODO Is there a better place for this constant? Since is it design related it probably shouldn't be here
const commentsToShow = 7;

//The Vue component for a single comment
Vue.component("latest-comment", {
  props: ["author-name", "author-avatar", "date", "body-text", "scroll-title", "scroll-name", "copy", "scroll-thumbnail", "num-of-comments", "thread-url"],

  template: require("./templates/latest-comment.html")
});

//The Vue component for the whole comment list
Vue.component("latest-comments-list", {
  data() {
    return {
      commentList: []
    };
  },

  template: require("./templates/latest-comments-list.html"),

  //on creation set up the list of comments
  created() {

    var threadIds = []; //ids of the threads in which the latest comments were made
    var latestThreads = {}; //holds objects with info about the above threads
    var filteredComments = []; //holds one comment from each thread

    //objects used for the data requeasts
    const disqusRequestPath = "/api/disqus";
    const commentsRequestData = {endpoint: "/posts/list.json"};
    const threadsRequestData = {endpoint: "/threads/list.json", thread: threadIds};

    //fetch comments data from disqus
    $.getJSON(disqusRequestPath, commentsRequestData, (returnedData) => {
      $.each(returnedData.response, function(index, comment) {
        var threadId = comment.thread;

        //keep only one comment from each thread
        if(threadIds.indexOf(threadId) < 0) {
          threadIds.push(threadId);

          //create fields which will be filled later using the thread metadata objects
          comment.scrollName = "";
          comment.scrollTitle = "";
          comment.scrollThumbnail = "";
          comment.threadUrl = "";
          comment.copy = "";

          //fix the formatting of the date
          var myMoment = moment(comment.createdAt);
          myMoment.locale(locale);
          comment.createdAt = myMoment.format("MMM D YYYY, H:mm");

          filteredComments.push(comment);
        }
      });

      //limit the number of comments to display
      this.commentList = filteredComments.slice(0, commentsToShow);

      if(this.commentList.length > 0) {
        //get the basic thread data (scroll id, scroll type and number of comments)
        $.getJSON(disqusRequestPath, threadsRequestData, (returnedData) => {
          latestThreads = parseThreads(returnedData);

          //now get the threads' metadata from the database (scroll names, titles and thumbnail urls)
          getThreadsMetadata(latestThreads, (threadsMetadata) => {
            //add the thread data to the comments
            for(var i=0; i<this.commentList.length; i++) {
              this.buildComment(i, threadsMetadata);
            }
          });
        });
      }
    });
  },

  updated() {
    truncateComments();
  },

  methods: {
    buildComment: function(i, threadsMetadata) {
      var threadId = this.commentList[i].thread;
      var threadMetadata = threadsMetadata[threadId];

      //check if the comment is on a manuscript or an image
      if(threadMetadata.type == "manuscript") {
        //add the manuscript name
        this.commentList[i].scrollName = threadMetadata.meta.manuscript_number+" - "+threadMetadata.meta.short_name;
        this.commentList[i].copy = threadMetadata.meta.copy;

        //find the manuscript title in the appropriate language
        if (locale=="he_IL") {
          this.commentList[i].scrollTitle = threadMetadata.meta.composition_name_he;
        }
        else {
          this.commentList[i].scrollTitle = threadMetadata.meta.composition_name_en;
        }
      }
      else {
        //add the scroll name
        this.commentList[i].scrollName = "Plate "+ threadMetadata.meta.plate_numbers[0];
        if(threadMetadata.meta.frag_num) {
          this.commentList[i].scrollName += ", frag. " + threadMetadata.meta.frag_num;
        }

        //add the scroll title
        this.commentList[i].scrollTitle = threadMetadata.id;
      }

      //add the scroll thumbnail
      this.commentList[i].scrollThumbnail =
        (threadMetadata.type == "manuscript") ? threadMetadata.meta.thumbnail : threadMetadata.meta.url;
      //add the number of comments in the thread
      this.commentList[i].numOfComments = threadMetadata.postCount;
      //add the thread url
      this.commentList[i].threadUrl = "/explore-the-archive/"+threadMetadata.type+"/"+threadMetadata.id;
    }
  }
});

function getThreadsMetadata(threads, callbackFunction) {
  // get names titles and thumbs from datastore:
  console.log("In getMetadata, attempting ajax call to get the metadata");

  $.ajax({
    url: "/api/meta",
    type: "POST",
    data: {
      list: JSON.stringify(threads)
    },

    success: function (data) {
      callbackFunction(data);
    }
  });
}

//Create a list of thread objects used to retrieve the threads' metadata
function parseThreads(data) {
  var threads = {};

  // parse types and id's of models:
  $.each(data.response, function (index, item) {
    var id = item.identifiers[item.identifiers.length-1];
    var slashIndex = id.indexOf("/");
    threads[item.id] = {
      type: id.substring(0, slashIndex),
      id: id.substring(slashIndex + 1),
      postCount: item.posts
    };
  });

  return threads;
}

function truncateComments() {
  $(".c-latest-comment__body-text").dotdotdot({
    height: "watch",
    truncate: "letter"
  });
}

//onload
$(() => {
  //The list of comments
  new Vue({
    el: "#latest-comments"
  });
});



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/latest-comments.js